export const UnsavedChangesPartnersKey = 'partners';
